<script setup lang="ts">
/** Icons of Console v2.dc.html `ic` (svgIc): circles and rectangles stay real shapes so they rasterise like the design. */
defineProps<{ name: string }>()
const paths: Record<string, string> = {
  channels: 'M4 6.5h16v11H4zM4 7l8 6 8-6',
  transactions: 'M8 3h11v18H8zM8 3a3 3 0 00-3 3v12a3 3 0 003 3M11 8h5M11 12h5M11 16h3',
  app: 'M4 10.5L12 4l8 6.5V20a1 1 0 01-1 1h-4v-6H9v6H5a1 1 0 01-1-1z',
  companies: 'M12 3v4M12 7h-5a2 2 0 00-2 2v2M12 7h5a2 2 0 012 2v2M5 11v2M19 11v2M3 15h4v6H3zM10 15h4v6h-4zM17 15h4v6h-4z',
  users: 'M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5M17 8.2a3 3 0 010 5.6M18 20c0-2.4-1-4-2.5-5',
  roles: 'M12 3l8 4v5c0 4.5-3.2 8.3-8 9.5-4.8-1.2-8-5-8-9.5V7z',
  entra: 'M11 11l8-8M16 4l3 3M13 7l3 3',
  welcome: 'M9 8V6a3 3 0 016 0v2M3 13h18',
  audit: 'M8 3h11v18H8zM8 3a3 3 0 00-3 3v12a3 3 0 003 3M11 8h5M11 12h5M11 16h3',
  sessions: 'M14 8a5 5 0 11-4-4M14 8l7 7-3 3-2-2-2 2-3-3',
  menu: 'M4 6h16M4 12h16M4 18h16', close: 'M6 6l12 12M6 18L18 6',
  collapse: 'M14 7l-5 5 5 5M4 4v16', search: 'M20 20l-3.5-3.5',
  chevron: 'M6 9l6 6 6-6', logout: 'M9 4H4v16h5M9 12h12M17 8l4 4-4 4',
}
</script>

<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.9"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle
      v-if="name === 'users'"
      cx="9"
      cy="8"
      r="3.2"
    />
    <circle
      v-if="name === 'entra'"
      cx="8"
      cy="14"
      r="4"
    />
    <circle
      v-if="name === 'search'"
      cx="11"
      cy="11"
      r="7"
    />
    <template v-if="name === 'templates' || name === 'welcome'">
      <rect
        x="3"
        y="8"
        width="18"
        height="12"
        rx="2"
      />
      <path d="M9 8V6a3 3 0 016 0v2M3 13h18" />
    </template>
    <!-- Console v2.dc.html:2786-2788 ic.lock / ic.key / ic.grid -->
    <template v-else-if="name === 'secrets'">
      <rect
        x="4.5"
        y="10.5"
        width="15"
        height="10"
        rx="2"
      />
      <path d="M8 10.5V7.5a4 4 0 018 0v3" />
    </template>
    <template v-else-if="name === 'keys'">
      <circle
        cx="8"
        cy="14"
        r="4"
      />
      <path d="M11 11l8-8M16 4l3 3M13 7l3 3" />
    </template>
    <template v-else-if="name === 'connections' || name === 'regions'">
      <rect
        v-for="[x, y] in [[4, 4], [14, 4], [4, 14], [14, 14]]"
        :key="`${x}-${y}`"
        :x="x"
        :y="y"
        width="6"
        height="6"
        rx="1.2"
      />
    </template>
    <path
      v-else
      :d="paths[name] ?? paths['companies']"
    />
  </svg>
</template>
